import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=dbd4387a&"
import script from "./categories.vue?vue&type=script&lang=js&"
export * from "./categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports